import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const SuggestedRulesList = ({
	suggestedRules,
	setSelectedRule,
	selectedRule,
}) => (
	<>
		{suggestedRules.map((rule, index) => (
			<Box
				onClick={() => setSelectedRule(rule)}
				key={index}
				sx={{
					backgroundColor:
						selectedRule?.title === rule.title
							? 'status.blue.bg'
							: 'background.paper', // suggested rules from LLM don't have an ID
					border: '0.5px solid',
					borderColor: 'border.light',
					borderRadius: '8px',
					padding: '12px 14px',
					cursor: 'pointer',
					transition: 'background-color 0.2s',
					'&:hover': {
						backgroundColor:
							selectedRule?.title === rule.title
								? 'status.blue.bg'
								: 'background.subtle', // not changing color on hover if item is already selected
					},
				}}
			>
				<Box sx={{ flex: 1, minWidth: 0 }}>
					<Box>
						<Typography
							sx={{
								fontSize: '13px',
								fontWeight: 600,
								color: 'text.primary',
								mb: 0.5,
							}}
						>
							{rule.title}
						</Typography>
						<Typography
							sx={{
								fontSize: '10px',
								color: 'text.secondary',
							}}
						>
							{rule?.message || ''}
						</Typography>
					</Box>
				</Box>
			</Box>
		))}
	</>
);

SuggestedRulesList.propTypes = {
	suggestedRules: PropTypes.arrayOf(PropTypes.object).isRequired,
	setSelectedRule: PropTypes.func.isRequired,
	selectedRule: PropTypes.object,
};

export default SuggestedRulesList;
